document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('.product__description');
  containers.forEach(function (container) {

    // widened heading test: h2-h6, OR a <p>/<div> whose entire
    // meaningful content is a single <strong>/<b> (short label text,
    // allowing a wrapping emoji / whitespace outside the bold run).
    function isHeading(n) {
      if (!n || n.nodeType !== 1) return false;
      if (/^H[2-6]$/.test(n.tagName)) return true;
      if (n.tagName === 'P' || n.tagName === 'DIV') {
        var strongs = n.querySelectorAll('strong, b');
        if (strongs.length !== 1) return false;
        if (n.querySelectorAll('*').length > 1) return false;
        var full = (n.textContent || '').trim();
        var bold = (strongs[0].textContent || '').trim();
        if (!bold) return false;
        var extra = full.replace(bold, '').trim();
        if (extra.length > 3) return false;
        if (bold.length === 0 || bold.length > 80) return false;
        return true;
      }
      return false;
    }

    // a node with no meaningful content: whitespace text, <br>, <meta>,
    // an empty element, an element that only holds image(s)/empty markup,
    // or a paragraph whose text is only punctuation/bullet (the stray ".").
    function isStray(n) {
      if (!n) return false;
      if (n.nodeType === 3) return !n.textContent.trim();
      if (n.nodeType !== 1) return true; // comments etc.
      if (n.tagName === 'BR' || n.tagName === 'META' || n.tagName === 'STYLE') return true;
      var t = (n.textContent || '').trim();
      if (t.length === 0) return true; // empty, or img-only wrapper
      return /^[\s.\u0964\u00B7\u2022\-\u2013\u2014*]+$/.test(t);
    }

    function cleanHeadingText(node) {
      var raw = node.textContent || '';
      return raw.replace(/^[\s\u2190-\u21FF\u2300-\u27BF\u2B00-\u2BFF\uFE00-\uFE0F\u200D\uD83C-\uDBFF\uDC00-\uDFFF]+/, '').trim();
    }

    // locate the element that actually holds the headings. Some
    // descriptions wrap everything in one or more <div>s, so a top-level
    // scan misses the h-tags. Pick the element whose DIRECT children
    // include the most headings.
    function directHeadingCount(el) {
      var c = 0, ch = el.childNodes;
      for (var k = 0; k < ch.length; k++) { if (isHeading(ch[k])) c++; }
      return c;
    }
    var work = container;
    var best = directHeadingCount(container);
    if (best === 0) {
      var all = container.getElementsByTagName('*');
      for (var a = 0; a < all.length; a++) {
        var dc = directHeadingCount(all[a]);
        if (dc > best) { best = dc; work = all[a]; }
      }
    }
    if (best === 0) return; // no headings anywhere: leave prose untouched

    // if the headings live inside a wrapper, drop leading stray siblings
    // (empty <p>, <img>-only <p>, <meta>, "." paragraphs) that render
    // above the description content.
    if (work !== container) {
      var branch = work;
      while (branch.parentNode && branch.parentNode !== container) branch = branch.parentNode;
      var sib = container.firstChild;
      while (sib && sib !== branch) {
        var next = sib.nextSibling;
        if (isStray(sib)) container.removeChild(sib);
        else break;
        sib = next;
      }
    }

    var kids = Array.prototype.slice.call(work.childNodes);

    var frag = document.createDocumentFragment();
    var i = 0;
    var headingsSeen = 0;

    // drop leading stray/empty/punctuation-only nodes inside work (".")
    while (i < kids.length && !isHeading(kids[i]) && isStray(kids[i])) {
      i++;
    }

    // intro: real nodes before the first heading stay as-is
    while (i < kids.length && !isHeading(kids[i])) {
      frag.appendChild(kids[i]);
      i++;
    }

    while (i < kids.length) {
      var head = kids[i];
      if (!isHeading(head)) {
        frag.appendChild(head);
        i++;
        continue;
      }
      headingsSeen++;

      if (headingsSeen === 1) {
        // FIRST heading group: visible intro, not collapsed
        var htag = /^H[2-6]$/.test(head.tagName) ? head.tagName.toLowerCase() : 'h3';
        var introHead = document.createElement(htag);
        introHead.className = 'gc-acc-intro-head';
        introHead.textContent = cleanHeadingText(head);
        frag.appendChild(introHead);
        i++;
        while (i < kids.length && !isHeading(kids[i])) {
          frag.appendChild(kids[i]);
          i++;
        }
        continue;
      }

      // SECOND heading onward: collapsible accordion row
      var details = document.createElement('details');
      details.className = 'gc-acc';
      var summary = document.createElement('summary');
      summary.className = 'gc-acc__head';
      summary.textContent = cleanHeadingText(head);
      details.appendChild(summary);
      var body = document.createElement('div');
      body.className = 'gc-acc__body';
      i++;
      while (i < kids.length && !isHeading(kids[i])) {
        body.appendChild(kids[i]);
        i++;
      }
      details.appendChild(body);
      frag.appendChild(details);
    }

    work.innerHTML = '';
    work.appendChild(frag);
  });
});
